export default "__VITE_ASSET__DfjdSHr5__"